import { BehaviorSubject, Observable } from 'rxjs';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-who-mobile',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, AngularSvgIconModule],
  templateUrl: './who-mobile.component.html',
  styleUrls: ['./who-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: WhoMobileComponent
    }
  ]
})
export class WhoMobileComponent implements ControlValueAccessor {
  @Input() public value!: number;
  @Input() public activeInput: string | undefined;
  @Output() public activeInputChange = new EventEmitter<string | undefined>();

  public places?: Observable<any>;
  public searching = new BehaviorSubject(false);
  public focused = new BehaviorSubject(false);

  // todo control valuea accessor on each element
  @ViewChild('whoInput')
  public whoInput?: ElementRef;

  showSearches: boolean = false;
  selection: any;
  focus?: string;
  

  public increment() {
    this.value = +this.value + 1;
    this.onChange(this.value);
  }

  public decrement() {
    this.value = +this.value - 1;
    this.onChange(this.value);
  }

  setFocus(focus: boolean) {
    this.focused.next(focus);
  }

   onChange = (value: number) => {};
   onTouched = () => {};

   private touched = false;

   public onBlurHandler() {
     if (!this.touched) {
       this.onTouched();
       this.touched = true;
     }
   }

   public writeValue(value: any): void {
     this.value = value;
   }

   public registerOnChange(onChange: any) {
     this.onChange = onChange;
   }

   public registerOnTouched(onTouched: any) {
     this.onTouched = onTouched;
   }

   public doUpdate(event: any) {
    const value = event.target.value;
    let parsed;
    if (typeof value === 'string') {
      parsed = parseInt(value);
    } else {
      parsed = value;
    }

    this.value = parsed
    this.onChange(this.value);
   }
}

